import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { useEnabledFeatures } from 'src/features/featureFlags/useFeatureFlags'
import {
  countTemplateNodes,
  resolveNodeSoftLimit,
} from 'src/features/templateEdit/countTemplateNodes'
import { RootState } from 'src/state/store'

/**
 * ひな形全体のノード数。全ノードを走査するので、ページ・ノードが変わるまで結果を使い回す。
 * このフックは複数のコンポーネントから呼ばれるが、走査は state の更新ごとに1回で済む。
 */
const selectTemplateNodeCount = createSelector(
  (state: RootState) => state.templatesState.templatePages.templatePages,
  (state: RootState) => state.templatesState.templatePages.templatePageIds,
  (state: RootState) => state.templatesState.templatePages.templateNodes,
  (templatePages, templatePageIds, templateNodes) =>
    countTemplateNodes({ templatePages, templatePageIds, templateNodes }),
)

/**
 * ひな形全体のノード数と、この企業のソフトリミット。
 * isReady が false の間はひな形または上限(拡張枠)が読み込み中で値が確定していないので、
 * 表示・判定に使わないこと。
 */
export const useTemplateNodeSoftLimit = (): {
  count: number
  limit: number
  isOverLimit: boolean
  isReady: boolean
} => {
  const count = useSelector(selectTemplateNodeCount)
  const isTemplateLoading = useSelector(
    (state: RootState) => state.templatesState.templatePages.isLoading,
  )
  const { features, isLoading: isFeaturesLoading } = useEnabledFeatures()
  const limit = resolveNodeSoftLimit(feature => features.includes(feature))
  const isReady = !isTemplateLoading && !isFeaturesLoading

  return {
    count,
    limit,
    isOverLimit: isReady && count > limit,
    isReady,
  }
}
